import {
  createUnifiedTheme,
  createBaseThemeOptions,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const orangeTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        // Orange brand: #ff7900 som bakgrunnsfarge, svart tekst gir 8:1 (WCAG AAA)
        // Orange bruker IKKE oransje som tekstfarge — lenker og tekst er svart
        main: '#ff7900',
        light: '#ff9133',
        dark: '#f16e00',
        contrastText: '#000000',
      },
      secondary: {
        main: '#000000',
        contrastText: '#ffffff',
      },
      error: {
        main: '#cd3c14', // Orange brand danger — 4.94:1 på hvit ✓
        contrastText: '#ffffff',
      },
      warning: {
        // Orange brand: #ffcc00 brukes som bakgrunn med svart tekst (13.9:1)
        // MUI Alert bruker warning.dark for tekst — ikke main direkte
        main: '#ffcc00',
        contrastText: '#000000',
      },
      info: {
        main: '#4170d8', // Orange brand blue — 4.63:1 på hvit ✓
        contrastText: '#ffffff',
      },
      success: {
        main: '#228722', // Orange brand green — 4.61:1 på hvit ✓
        contrastText: '#ffffff',
      },
      navigation: {
        background: '#000000',
        indicator: '#ff7900',
        color: '#ffffff',
        selectedColor: '#ff7900',
        navItem: {
          hoverBackground: '#1a1a1a',
        },
        submenu: {
          background: '#1a1a1a',
        },
      },
      background: {
        default: '#f6f6f6',
        paper: '#ffffff',
      },
      text: {
        primary: '#000000',
        secondary: '#666666',
      },
    },
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#ff7900', '#f16e00'], shape: shapes.wave }),
    documentation: genPageTheme({ colors: ['#000000', '#333333'], shape: shapes.wave2 }),
    tool: genPageTheme({ colors: ['#f16e00', '#ff7900'], shape: shapes.round }),
    service: genPageTheme({ colors: ['#000000', '#ff7900'], shape: shapes.wave }),
    website: genPageTheme({ colors: ['#f16e00', '#000000'], shape: shapes.wave }),
    library: genPageTheme({ colors: ['#333333', '#666666'], shape: shapes.wave2 }),
    other: genPageTheme({ colors: ['#ff7900', '#000000'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#000000', '#f16e00'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#ff7900', '#f16e00'], shape: shapes.wave2 }),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#ff7900',
          color: '#000000',
          '&:hover': {
            backgroundColor: '#f16e00',
          },
        },
        // Orange brand: outline- og text-knapper bruker svart (secondary-stil)
        // Unngår oransje tekst på hvit bakgrunn (2.63:1 — WCAG-fail)
        outlinedPrimary: {
          color: '#000000',
          borderColor: '#000000',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
            borderColor: '#000000',
          },
        },
        textPrimary: {
          color: '#000000',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
          },
        },
      },
    },
    // Orange brand: lenker skal være svarte, ikke oransje
    // Oransje (#ff7900) brukes kun som bakgrunnsfarge, aldri som tekstfarge
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#000000',
          '&:hover': {
            color: '#ff7900',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  },
});
